import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import PriceMain from "./PriceMain";
import Footer from "../../components/Footer";

const Price = () => {
  return (
    <>
      <HeaderFour />

      <PriceMain />

      <Footer />
    </>
  );
};

export default Price;
